import type { InputHTMLAttributes, JSX } from "preact";
import { classNames } from "@gss/common/classNames";
import "./formCheckInput.css";

export interface InputCheckboxProps extends Omit<
    InputHTMLAttributes,
    "type" | "onChange" | "role"
> {
    role?: "checkbox" | "switch";
    className?: string;
    invalid?: boolean;
    warning?: boolean;
    onChange?: (checked: boolean) => void;
}

export function InputCheckbox({
    role = "checkbox",
    className,
    invalid,
    warning,
    onChange,
    ...rest
}: InputCheckboxProps): JSX.Element {
    return (
        <input
            {...rest}
            type="checkbox"
            role={role}
            className={classNames(
                "form-check-input",
                invalid && "is-invalid",
                warning && !invalid && "bg-warning",
                className,
            )}
            onChange={
                onChange ? (e) => onChange(e.currentTarget.checked) : undefined
            }
        />
    );
}
